import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { StoreContext } from '../../contexts/StoreContext';
import Logo from '../Login/Logo';
import UserMenu from '../UserMenu/UserMenu';
import styles from './Header.module.css';

const Header = observer(() => {
    const rootStore = useContext(StoreContext);
    const [serverStatus, setServerStatus] = useState('checking'); // 'online', 'offline', 'checking'
    
    // Получаем базовый API путь из модели роутов
    const apiBase = rootStore.models?.schemas?.routes?.apiBase;

    useEffect(() => {
        // Проверка статуса сервера
        const checkServerStatus = async () => {
            try {
                // Используем apiClient с базовым путем из модели
                const response = await rootStore.apiClient.get(apiBase);
                if (response && response.status) {
                    setServerStatus(response.status === 'online' ? 'online' : 'offline');
                } else {
                    setServerStatus('offline');
                }
            } catch (error) {
                setServerStatus('offline');
            }
        };

        checkServerStatus();
        // Проверяем каждые 30 секунд
        const interval = setInterval(checkServerStatus, 30000);
        return () => clearInterval(interval);
    }, []);

    return (
        <header className={styles.header}>
            <div className={styles.container}>
                <div className={styles.logo}>
                    <Logo className={styles.logoSvg} />
                </div>
                
                <nav className={styles.nav}>
                    <NavLink
                        to="/"
                        className={({ isActive }) => `${styles.navLink} ${styles.navHome} ${isActive ? styles.active : ''}`}
                        end
                    >
                        Главная
                    </NavLink>
                    <NavLink
                        to="/projects"
                        className={({ isActive }) => `${styles.navLink} ${styles.navProjects} ${isActive ? styles.active : ''}`}
                    >
                        Проекты
                    </NavLink>
                    <NavLink
                        to="/templates"
                        className={({ isActive }) => `${styles.navLink} ${styles.navTemplates} ${isActive ? styles.active : ''}`}
                    >
                        Шаблоны
                    </NavLink>
                    <NavLink
                        to="/settings"
                        className={({ isActive }) => `${styles.navLink} ${styles.navSettings} ${isActive ? styles.active : ''}`}
                    >
                        Настройки
                    </NavLink>
                </nav>
                
                <div className={styles.user}>
                    <div className={`${styles.serverStatus} ${styles[serverStatus]}`}>
                        <span className={styles.statusIndicator}></span>
                        <span className={styles.statusText}>
                            {serverStatus === 'online' ? 'Онлайн' : 
                             serverStatus === 'offline' ? 'Офлайн' : 'Проверка...'}
                        </span>
                    </div>
                    <UserMenu />
                </div>
            </div>
        </header>
    );
});

export default Header;